// extracted by mini-css-extract-plugin
module.exports = {"iframe":"IframeBlock_iframe__f1iZP","mod-aspectratio":"IframeBlock_mod-aspectratio__zIbps"};